import { countdownTickCreator, REHYDRATED } from '../actions';
import { hasActiveCountdowns } from '../selectors';

function initializeCountdowns(store) {
  const dispatchTick = () => {
    store.dispatch(countdownTickCreator());
    if (hasActiveCountdowns(store.getState())) {
      setTimeout(dispatchTick, 1000);
    }
  };
  dispatchTick();
}

export default store => next => action => {
  const ret = next(action);
  if (action.type === REHYDRATED && hasActiveCountdowns(store.getState())) {
    initializeCountdowns(store);
  }
  return ret;
};
